import { 
    SUBMIT_FLEX_CLAIM_SUCCESS, 
    SUBMIT_FLEX_CLAIM_ERROR, 
    GET_CLAIM_PHOTO_SUCCESS,
    GET_CLAIM_PHOTO_ERROR,
    GET_CLAIMS,
    GET_INPATIENT_CLAIM_SUCCESS,
    // GET_INPATIENT_CLAIM_ERROR,
    GET_OUTPATIENT_CLAIM_SUCCESS,
    GET_SINGLE_OUTPATIENT_CLAIM_ID_SUCCESS,
    GET_SINGLE_INPATIENT_CLAIM_ID_SUCCESS,
    DELETE_OUTPATIENT_CLAIM_ID_SUCCESS,
    // GET_OUTPATIENT_CLAIM_ERROR,
    DELETE_OUTPATIENT_CLAIM_SUCCESS,
    // DELETE_OUTPATIENT_CLAIM_ERROR,
    UPDATE_OUTPATIENT_CLAIM_SUCCESS,
    UPDATE_UNSUBMITTED_OUTPATIENT_CLAIM_SUCCESS,
    // UPDATE_OUTPATIENT_CLAIM_ERROR,
    UPDATE_INPATIENT_CLAIM_SUCCESS,
    UPDATE_UNSUBMITTED_INPATIENT_CLAIM_SUCCESS,
    // UPDATE_INPATIENT_CLAIM_ERROR,
    GET_CLAIMS_SUCCESS,
    // GET_CLAIMS_ERROR,
    GET_SINGLE_INPATIENT_CLAIM_SUCCESS,
    // GET_SINGLE_INPATIENT_CLAIM_ERROR,
    GET_SINGLE_OUTPATIENT_CLAIM_SUCCESS,
    // GET_SINGLE_OUTPATIENT_CLAIM_ERROR,
    UPDATE_CLAIM_FILTER_OPTIONS,
    GET_CLAIM_OPTIONS_SUCCESS,
    GET_CLAIM_OPTIONS_REQUEST,
    GET_CLAIM_OPTIONS_ERROR

} from '../actions';
import _ from 'underscore';
import moment from 'moment';
// import { bindActionCreators } from 'redux';

const initialFilterOptions = {
    fromDate: moment().subtract(1, 'months'),
    toDate: moment(),
    filterByClaimant: null,
    filterByCompany: null
}

const initialState = {
    claims: [],
    inpatientClaims: [],
    outpatientClaims: [],
    data: [],
    viewed: {},
    claimImage: [],
    claimSingleImage: {},
    filterOptions: initialFilterOptions,
    isLoaded: false,
    message:null
};

export default function(state = initialState, action) {
    switch(action.type) {
        case UPDATE_CLAIM_FILTER_OPTIONS:
            return Object.assign({}, state, {filterOptions: action.payload});
        case GET_SINGLE_OUTPATIENT_CLAIM_SUCCESS:
            const convertedSingleOutpatientClaimKeyObj = _.indexBy([action.payload.data.outpatientclaim], 'transactionNo');
            const newOutpatientViewedObj = Object.assign({}, state.viewed, convertedSingleOutpatientClaimKeyObj);
            return Object.assign({}, state, {viewed: newOutpatientViewedObj});
        case GET_SINGLE_OUTPATIENT_CLAIM_ID_SUCCESS:
            const convertedSingleOutpatientClaimKeyObj2 = _.indexBy([action.payload.data.outpatientclaim], '_id');
            const newOutpatientViewedObj2 = Object.assign({}, state.viewed, convertedSingleOutpatientClaimKeyObj2);
            return Object.assign({}, state, {viewed: newOutpatientViewedObj2});
        case GET_SINGLE_INPATIENT_CLAIM_SUCCESS:
            const convertedClaimKeyObj = _.indexBy([action.payload.data.inpatientclaim], 'transactionNo');
            const newViewedObj = Object.assign({}, state.viewed, convertedClaimKeyObj);
            return Object.assign({}, state, {viewed: newViewedObj});
        case GET_SINGLE_INPATIENT_CLAIM_ID_SUCCESS:
            const convertedClaimKeyObj2 = _.indexBy([action.payload.data.inpatientclaim], '_id');
            const newViewedObj2 = Object.assign({}, state.viewed, convertedClaimKeyObj2);
            return Object.assign({}, state, {viewed: newViewedObj2});
        case GET_CLAIMS_SUCCESS:
            return Object.assign({}, state, {data: action.payload.data.records, isLoaded: true});
        case GET_CLAIMS:
            return Object.assign({}, state, {claims: action.payload.data.eclaims})
        case GET_INPATIENT_CLAIM_SUCCESS: 
            return Object.assign({}, state, {inpatientClaims: action.payload.data.inpatientclaims});
        case GET_OUTPATIENT_CLAIM_SUCCESS:
            return Object.assign({}, state, {outpatientClaims: action.payload.data.outpatientclaims, isLoaded: true});
        case SUBMIT_FLEX_CLAIM_SUCCESS:
            return state;
        case SUBMIT_FLEX_CLAIM_ERROR:
            return state;
        case DELETE_OUTPATIENT_CLAIM_SUCCESS:
            return state;
        case DELETE_OUTPATIENT_CLAIM_ID_SUCCESS:
            return state;
        case GET_CLAIM_PHOTO_SUCCESS:
            const imageType = action.payload.headers['content-type'];
            let attachedObject = {}
            let attachmentAll = state.claimImage
            attachedObject.objectId = action.dataId
            attachedObject.attachmentLink = 'data:' + imageType + ';base64,' + new Buffer(action.payload.data, 'binary').toString('base64')
            attachmentAll.push(attachedObject)
            return Object.assign({}, state, {claimImage: attachmentAll, claimSingleImage: attachedObject});
        case GET_CLAIM_PHOTO_ERROR:
            return Object.assign({}, state, {claimSingleImage: {}});
        case UPDATE_OUTPATIENT_CLAIM_SUCCESS:
            const convertedUpdateOutpatientClaimKeyObj = _.indexBy(action.payload.data.outpatientclaims, 'transactionNo');
            const newUpdateOutpatientViewedObj = Object.assign({}, state.viewed, convertedUpdateOutpatientClaimKeyObj);
            return Object.assign({}, state, {viewed: newUpdateOutpatientViewedObj});
        case UPDATE_UNSUBMITTED_OUTPATIENT_CLAIM_SUCCESS:
            const convertedUpdateOutpatientClaimKeyObj2 = _.indexBy(action.payload.data.outpatientclaims, '_id');
            const newUpdateOutpatientViewedObj2 = Object.assign({}, state.viewed, convertedUpdateOutpatientClaimKeyObj2);
            return Object.assign({}, state, {viewed: newUpdateOutpatientViewedObj2});
        case UPDATE_INPATIENT_CLAIM_SUCCESS:
            const convertedUpdateClaimKeyObj = _.indexBy(action.payload.data.inpatientclaims, 'transactionNo');
            const newUpdateViewedObj = Object.assign({}, state.viewed, convertedUpdateClaimKeyObj);
            return Object.assign({}, state, {viewed: newUpdateViewedObj});
        case UPDATE_UNSUBMITTED_INPATIENT_CLAIM_SUCCESS:
            const convertedUpdateClaimKeyObj2 = _.indexBy(action.payload.data.inpatientclaims, '_id');
            const newUpdateViewedObj2 = Object.assign({}, state.viewed, convertedUpdateClaimKeyObj2);
            return Object.assign({}, state, {viewed: newUpdateViewedObj2});
        case GET_CLAIM_OPTIONS_REQUEST:
            return Object.assign({}, state, {isLoaded: true});
        case GET_CLAIM_OPTIONS_SUCCESS:
            return Object.assign({}, state, {payload: action.payload, isLoaded: false});
        case GET_CLAIM_OPTIONS_ERROR:
            return Object.assign({}, state, {isLoaded: false});
        default:
            return state;
    }
}